import get from 'lodash/get';
import {
  fetchLvmSalesHistory,
  downloadLvmSalesHistoryReport,
  fetchLvmSales,
} from 'dashboard/actions/lvm-sales-history/lvm-sales-history.actions';
import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import LvmSalesHistoryTemplate from './lvm-sales-history.html';
import tabs from '../../tabs';

const mapStateToThis = ({ session, lvmSalesHistory, ui, dictionary }) => {
  const { data, total, isLoading } = lvmSalesHistory;
  const { locale } = session;
  const { activeTab } = ui;
  const { WTD, MTD, QTD, YTD } = tabs;
  const terms = dictionary.terms[locale];

  return {
    data,
    total,
    isLoading,
    locale,
    activeTab,
    WTD,
    MTD,
    QTD,
    YTD,
    terms,
  };
};

const mapDispatchToThis = {
  setActiveTab,
  fetchLvmSales,
  fetchLvmSalesHistory,
  downloadLvmSalesHistoryReport,
};

@Inject('$ngRedux', 'gettextCatalog', '$state', 'Responsive', '$window', 'tableService')
class LvmSalesHistoryController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.isYear = false;
    this.instantGamesText = this.gettextCatalog.getString('{{ instant }} Games', { instant: this.terms.INSTANT.singular });
    this.drawGamesText = this.gettextCatalog.getString('{{ draw }} Games', { draw: this.terms.DRAW.singular });
    this.tableConfig = this.tableService.initConfig({ configName: 'lvmSalesHistory' });
    this.retailerId = get(this.$state, 'params.retailerNo');
    this.headers = this.getHeaders();
    if (this.total.length === 0) {
      await this.fetchLvmSales(this.retailerId);
    }
    await this.onTabSelect();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onChangePeriodYear(isYear) {
    this.isYear = isYear;
    const { salesTotal, salesDeltaYear, deltaAsPercYear, salesDeltaPeriod, deltaAsPercPeriod } =
      this.total.find((item) => item.periodType === this.activeTab) || {};
    this.currentTotalTab = salesTotal;
    if (this.isYear) {
      this.currentDeltaTab = salesDeltaYear;
      this.currentDeltaAsPercTab = deltaAsPercYear;
    } else {
      this.currentDeltaTab = salesDeltaPeriod;
      this.currentDeltaAsPercTab = deltaAsPercPeriod;
    }
  }

  getHeaders() {
    return [
      {
        field: 'expand',
      },
      {
        text: this.gettextCatalog.getString('LVM No.'),
        field: 'terminalKey',
      },
      {
        /// {{ draw }} is Lottery term using to determine Draw games.
        text: this.gettextCatalog.getString('{{ draw }} Games', { draw: this.terms.DRAW.singular }),
        field: 'drawTotal',
      },
      {
        /// {{ instant }} is Lottery term using to determine Instant games.
        text: this.gettextCatalog.getString('{{ instant }} Games', { instant: this.terms.INSTANT.singular }),
        field: 'instantTotal',
      },
      {
        text: this.gettextCatalog.getString('Total Sales'),
        field: 'total',
      },
    ];
  }

  async onTabSelect(tab = 'WTD') {
    this.setActiveTab(tab, 'activeTab');
    this.onChangePeriodYear(false);
    await this.fetchLvmSalesHistory(this.activeTab, this.retailerId);
  }

  toggleExpand(item, index) {
    const expandContainerClass = `expand-container-${index}`;
    const expandContainer = this.$window.document.getElementsByClassName(expandContainerClass);

    if (!item.isExpanded) {
      setTimeout(() => {
        const innerContainerClass = `expand-inner-container-${index}`;

        const height = this.$window.document.getElementsByClassName(innerContainerClass)[0].clientHeight;

        expandContainer[0].style.height = `${height}px`;
      }, 50);
    }

    if (item.isExpanded) {
      expandContainer[0].style.height = '0px';
    }

    item.isExpanded = !item.isExpanded;
  }

  onDownloadReport(format) {
    return this.downloadLvmSalesHistoryReport(format, this.activeTab, this.retailerId);
  }
}

export default class LvmSalesHistoryComponent {
  constructor() {
    this.template = LvmSalesHistoryTemplate;
    this.controller = LvmSalesHistoryController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/lvm-sales/components/lvm-sales-history/lvm-sales-history-component.js